import jwtDecode from 'jwt-decode';

// eslint-disable-next-line no-unused-vars
export const checkTokenExpirationMiddleware = store => next => action => {
  try {
    const token = JSON.parse(localStorage.getItem('auth'))?.authorization?.token;
    if (token && jwtDecode(token) && jwtDecode(token)?.exp < Date.now() / 1000) {
      next(action);
      localStorage.clear();
    }
    next(action);
  } catch (error) {
    localStorage.clear();
  }
};
